// Tag.js
import React, { useEffect, useState } from 'react';
import { handleConnect, setupPrints, readMessages, setUpdateBatteryCallback, setUpdateIdCallback } from '../../utils/SerialTag';
import './Tag.css';
import Sidebar from "../sidebar/sidebar";

const Tag = () => {
  const [batteryPercentage, setBatteryPercentage] = useState(null);
  const [connecting, setConnecting] = useState(false);
  const [connected, setConnected] = useState(false);
  const [firstBatteryMessageReceived, setFirstBatteryMessageReceived] = useState(false);
  const [deviceId, setDeviceId] = useState(null);

  const handleConnectClick = async () => {
    if (!connecting && !connected) {
      setConnecting(true);
      await handleConnect();
      setupPrints();
      readMessages();
      setConnected(true);
      setConnecting(false);
    }
  };

  useEffect(() => {
    const updateBatteryPercentage = (percentage) => {
      setBatteryPercentage(percentage);

      if (!firstBatteryMessageReceived && percentage !== null) {
        setFirstBatteryMessageReceived(true);
      }
    };

    const updateDeviceId = (id) => {
      setDeviceId(id);
    };

    setUpdateBatteryCallback(updateBatteryPercentage);
    setUpdateIdCallback(updateDeviceId);

    return () => {
      setUpdateBatteryCallback(null);
      setUpdateIdCallback(null);
    };
  }, [firstBatteryMessageReceived]);

  return (
    <div className="Tag">
      <Sidebar/>
      <header className="Tag-header">
        <div className="logo-container">
          <img src={'/StraconTech.png'} alt={'stracon'}/>
        </div>
        {connected &&
            <div className="battery-container">
              {connected && <p>{`Porcentaje de batería: ${batteryPercentage !== null ? batteryPercentage.toFixed(2) : connected ? 'Cargando...' : ''}`}</p>}
              <div className={`battery-bar${connecting || (!connected && batteryPercentage === null && !firstBatteryMessageReceived) ? ' loading' : ''}`}>
                <div
                  className="battery-fill"
                  style={{ width: `${batteryPercentage || 0}%` }}
                ></div>
                {(connected && batteryPercentage === null) && <div className="loading-text">Cargando...</div>}
              </div>
            </div>
        }

        {deviceId !== null && (
          <div className="id-container">
            <div>{`ID del dispositivo: ${deviceId}`}</div>
          </div>
        )}

        {!connected && (
          <button className={`connect-button${connecting ? ' hidden' : ''}`} onClick={handleConnectClick} disabled={connecting}>
            {connecting ? 'Conectando...' : 'Conectar Dispositivo'}
          </button>
        )}
      </header>
    </div>
  );
};

export default Tag;
